export const TASK_TYPE_LABEL = {
  approval: 'Approval',
  work: 'Work',
  review: 'Review',
  assignment: 'Assignment',
};

export const SOURCE_ARTEFACT_LABEL = {
  requirement: 'Requirement',
  disposition: 'Disposition',
  build_item: 'Build item',
  gate_condition: 'Gate',
  functional_spec: 'Functional spec',
  test_script: 'Test script',
  defect: 'Defect',
};

export function isTaskOverdue(task) {
  if (!task?.due_date) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return new Date(task.due_date) < today;
}

/** Navigate target for §22.7 — opens the screen the task belongs to. */
export function getTaskDestination(task) {
  if (!task?.project_id) return null;

  const base = `/project/${task.project_id}`;

  switch (task.source_artefact_type) {
    case 'disposition':
      return {
        pathname: `${base}/workbench/build/disposition`,
        search: `?focusReq=${task.source_artefact_id}`,
      };
    case 'requirement':
      return {
        pathname: `${base}/initiation/requirements`,
        search: `?focusReq=${task.source_artefact_id}`,
      };
    case 'build_item':
      return {
        pathname: `${base}/workbench/build/tracker`,
        search: `?focusItem=${task.source_artefact_id}`,
      };
    case 'functional_spec':
      return {
        pathname: `${base}/workbench/design/functional-specs`,
        search: `?focusSpec=${task.source_artefact_id}`,
      };
    case 'test_script':
      return {
        pathname: `${base}/workbench/test/scripts`,
        search: `?focusTest=${task.source_artefact_id}`,
      };
    case 'defect':
      return {
        pathname: `${base}/workbench/test/defects`,
        search: `?focusDefect=${task.source_artefact_id}`,
      };
    case 'gate_condition':
      return {
        pathname: `${base}/governance/stage-gates`,
        search: `?focusCondition=${task.source_artefact_id}`,
      };
    default:
      return { pathname: base, search: '' };
  }
}

export function formatTaskDue(dueDate) {
  if (!dueDate) return null;
  return new Date(dueDate).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
  });
}

export function taskMetaLine(task) {
  const type = TASK_TYPE_LABEL[task.task_type] || task.task_type;
  const source = SOURCE_ARTEFACT_LABEL[task.source_artefact_type] || task.source_artefact_type;
  const project = task.projects?.name;
  return [type, source, project].filter(Boolean).join(' · ');
}
